import { render, staticRenderFns } from "./IconInputBg.vue?vue&type=template&id=638e139e&scoped=true&"
import script from "./IconInputBg.vue?vue&type=script&lang=js&"
export * from "./IconInputBg.vue?vue&type=script&lang=js&"
import style0 from "./IconInputBg.vue?vue&type=style&index=0&id=638e139e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e139e",
  null
  
)

export default component.exports